module.exports = __webpack_public_path__ + "img/669.32efc0bd.png";